import { isFirefox } from '@lib/util/userAgents'

export const isImageAccessible = (url: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = () => {
      const isSvg = url.toLowerCase().includes('.svg')
      const skipSvgCheck = isFirefox && isSvg // if svg not have height and width, firefox can't calculate naturalWidth and naturalHeight
      if (skipSvgCheck || (img.naturalWidth > 0 && img.naturalHeight > 0)) {
        resolve(url)
      } else {
        reject(new Error('Image loaded but has invalid dimensions'))
      }
    }

    img.onerror = () => {
      reject(new Error('Image not accessible'))
    }

    img.src = url
  })
}

/**
 * Generates an AI thumbnail URL for an img based on its description
 * @param imgDesc - Description to generate thumbnail for
 * @returns URL to the AI-generated thumbnail
 */
export const generateAIThumbnailUrl = (imgDesc: string): string => {
  if (!imgDesc) return ''

  // Encode the canvas name for use in the URL
  const encodedImgDesc = encodeURIComponent(imgDesc)
  return `https://zero.pitcher.com/ai/generatePictureURL.php?completeText=${encodedImgDesc}`
}

export function getImageSize(url: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = function () {
      const size = {
        width: img.naturalWidth,
        height: img.naturalHeight,
      }

      img.remove()
      resolve(size)
    }

    img.onerror = function () {
      img.remove()
      reject(new Error('Failed to load image'))
    }

    img.src = url
  })
}
